import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-redirect"
export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 2000 }
  }

  connect() {
    // Redirect after the specified delay
    setTimeout(() => {
      window.location.href = this.urlValue
    }, this.delayValue)
  }
}